import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Input } from '@app/components/common/inputs/Input/Input';
import { Modal } from '@app/components/common/Modal/Modal';
import { IDealRoomShare } from '@app/interfaces/deal-room';
import mainLogo from 'assets/main-logo.svg';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './DealRoomInviteModal.styles';
import { IUser } from '@app/interfaces/user';
import { phoneRegex } from '@app/constants/regex';

interface DealRoomInviteModalProps {
  isOpen: boolean;
  loading: boolean;
  user: IUser | null;
  onFinish: (data: { email: string; firstName: string; lastName: string; phone: string }) => void;
  dealRoom: IDealRoomShare;
}

export const DealRoomInviteModal: React.FC<DealRoomInviteModalProps> = ({
  isOpen,
  loading,
  onFinish,
  dealRoom,
  user,
}) => {
  const { t } = useTranslation();

  const [form] = BaseForm.useForm();
  const inviteFormValues = {
    firstName: '',
    lastName: '',
    phone: '',
  };

  useEffect(() => {
    if (dealRoom?.people) {
      form.setFieldsValue({
        firstName: dealRoom?.people?.firstName,
        lastName: dealRoom?.people?.lastName,
        phone: dealRoom?.people?.phone,
      });
    }
  }, [dealRoom?.people, form]);

  return (
    <>
      <Modal
        className="dealRoomInviteModal"
        size="medium"
        open={isOpen}
        title={
          <S.MailLogoWrapper>
            <img className="app-logo" src={mainLogo} alt="Logo" />
          </S.MailLogoWrapper>
        }
        footer={false}
        destroyOnClose
        closable={false}
        confirmLoading={loading}
      >
        <S.ModelTTitle>{t('dealRooms.landing.form.connection')}</S.ModelTTitle>
        <BaseForm
          initialValues={inviteFormValues}
          form={form}
          layout="vertical"
          name="dealRoomInviteForm"
          onFinish={onFinish}
        >
          <BaseForm.Item
            name="firstName"
            label={t('dealRooms.landing.form.firstName')}
            rules={[{ required: true, message: t('dealRooms.landing.form.firstNameRequired') }]}
          >
            <Input />
          </BaseForm.Item>
          <BaseForm.Item name="lastName" label={t('dealRooms.landing.form.lastName')}>
            <Input />
          </BaseForm.Item>
          <BaseForm.Item
            name="phone"
            label={t('dealRooms.landing.form.phone')}
            rules={[
              { required: true, message: t('dealRooms.landing.form.phoneRequired') },
              { pattern: new RegExp(phoneRegex), message: t('common.shouldBeANumber') },
              { min: 6, message: t('common.phoneNumberLengthError') },
            ]}
          >
            <Input disabled={!!dealRoom?.people?.phone || !!user} />
          </BaseForm.Item>
          <S.FooterWrapper>
            <BaseButtonsForm.Item>
              <S.ButtonWrapper htmlType="submit" type="primary" loading={loading}>
                {t('dealRooms.landing.form.connection')}
              </S.ButtonWrapper>
            </BaseButtonsForm.Item>
          </S.FooterWrapper>
        </BaseForm>
      </Modal>
    </>
  );
};
